export default __webpack_public_path__ + "static/media/video7.39a97b55.mp4";